import { render, staticRenderFns } from "./DewormingFirstPage.vue?vue&type=template&id=8dd32628&scoped=true&"
import script from "./DewormingFirstPage.vue?vue&type=script&lang=js&"
export * from "./DewormingFirstPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd32628",
  null
  
)

export default component.exports